import { Component, inject, OnInit } from '@angular/core';
import { SubStepEnum } from '../models/sub-step.enum';
import { MaterialSubStepService } from '../services/material-sub-step.service';
import { Installation } from '../../../../../models/configurators-2d/applications/fence/installations/installation';
import { FenceService } from '../../../../../services/configurators-2d/applications/fence.service';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '../../../../../services/modal.service';
import { InstallationStateService } from '../../services/installation.state.service';
import { InstallationTypeEnum } from 'src/app/enum/fence/installation-type.enum';

@Component({
  selector: 'ng-casto-materials-installations',
  templateUrl: './materials-installations.component.html',
  styleUrl: './materials-installations.component.scss',
})
export class MaterialsInstallationsComponent implements OnInit {
  protected readonly SubStepEnum = SubStepEnum;
  protected readonly InstallationTypeEnum = InstallationTypeEnum;
  private readonly translateService = inject(TranslateService);
  private readonly materialSubStepService = inject(MaterialSubStepService);
  private readonly fenceService = inject(FenceService);
  private readonly installationStateService = inject(InstallationStateService);
  protected readonly modalService = inject(ModalService);

  baseImgURL: string = undefined;

  /** Langue sélectionnée */
  currentLang: string;

  constructor() {
    this.baseImgURL = this.fenceService.apiUrl;
  }

  ngOnInit(): void {
    this.currentLang = this.translateService.getBrowserLang();
  }

  /**
   * Retourne la liste des poses disponibles
   * @protected
   */
  protected get installations(): Installation[] {
    return this.installationStateService.installations();
  }

  /**
   * Retourne la sous-étape courante du composant
   * @protected
   */
  protected get subStep(): SubStepEnum {
    return this.materialSubStepService.subStep();
  }

  /**
   * Gère l'affichage/masquage des sous-menus en accordéon
   * @param step étape à afficher
   */
  protected toggleCollapse(step: SubStepEnum): void {
    this.materialSubStepService.toggleCollapse(step);
  }
}
